// {{component}}.js
import {getRedPacketRecordDetail} from "../../../api/index"
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    item: {
      type: Object,
      value: {}
    },
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    myRecord:{},
    record:[],
    send_info:{},
    nowAllMoney:0,
    loading: true
  },
  lifetimes:{
    attached(){
      const params = {
        app_id: this.data.appId,
        alive_id: this.data.alive_id,
        red_packet_id: this.data.item.id,
        user_id: this.data.userId,
        limit:1000,
        page:1     
      }
      this.setData({
        loading:true
      })
      getRedPacketRecordDetail(params).then(res=>{
        console.log("领取记录",res.data.data);
        let list =  res.data.data.record_list;
        let record = [];
        let myRecord = {};
        let nowAllMoney = 0
        list.forEach((item)=>{
          nowAllMoney += Number(item.money);
          if(item.user_id == this.data.userId){
            myRecord = item;
          }else {
            record.push(item)
          }
        });
        this.setData({
          record,
          myRecord,
          send_info: res.data.data.send_info,
          nowAllMoney,
          loading: false
        },()=>{
          console.log(this.data.record,this.data.myRecord);
        })
      })
    }
  },
  /**
   * 组件的方法列表
   */
  methods: {

  }
})
